import { updateNetworkProfile } from '@infuse/api/e-connector/network-profile';
import { useNotify } from '@infuse/cpms/ui';
import { mapToApi, NetworkProfile } from '@infuse/e-connector/network-profile/domain';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useUpdateNetworkProfile = () => {
  const queryClient = useQueryClient();
  const { notifySuccess, notifyFailure } = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  return useMutation({
    mutationFn: (networkProfile: NetworkProfile) => {
      const apiNetworkProfile = mapToApi(networkProfile);
      return updateNetworkProfile({ id: apiNetworkProfile.id }, apiNetworkProfile);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['network-profiles'] });

      notifySuccess({
        title: t('e_connector.common.notify.success'),
        message: t('e_connector.networkProfiles.notify.update.success')
      });
    },
    onError: (error) => {
      notifyFailure({
        title: t('e_connector.common.notify.error'),
        message: t('e_connector.networkProfiles.notify.update.error', {
          reason: getAxiosErrorMessage(error, '')
        })
      });
    }
  });
};
